import React from 'react';
import classes from './ThemeSlidingSwitch.scss';

import nightThemeImage from '../../../assets/images/night-theme.svg';
import dayThemeImage from '../../../assets/images/day-theme.svg';

const ThemeSlidingSwitch = (props) => {
    return (
        <label className={classes.Switch}>
            <input type="checkbox" {...props} />
            <div className={classes.ImageContainer}>{props.theme === 'light' ? <img src={dayThemeImage} alt="Day Theme" /> : <img src={nightThemeImage} alt="Night Theme" />}</div>
            <span className={classes.Slider}></span>
        </label>
    );
}

export default ThemeSlidingSwitch;




// WEBPACK FOOTER //
// ./src/components/ThemeSwitch/ThemeSlidingSwitch/ThemeSlidingSwitch.js